const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/AppointmentTitleRow.tsx';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { getStructuredAppointmentTitle } from 'App/utils/appointment';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';

type AppointmentTitleProps = {
    appointment: StructuredAppointment;
};

export const AppointmentTitleRow = (props: AppointmentTitleProps) => {
    const { formatMessage } = useIntl();

    return (
        <Grid size={{ xs: 12 }}>
            <Typography variant={'h6'}>{getStructuredAppointmentTitle(props.appointment, formatMessage)}</Typography>
        </Grid>
    );
};
